export default Object.freeze( {
    floating: 'floating',
    modal: 'modal',
    standard: 'standard',
    undefined: 'persistent',
} );
